import { render, staticRenderFns } from "./InfoField.vue?vue&type=template&id=80745c02"
import script from "./InfoField.vue?vue&type=script&lang=ts"
export * from "./InfoField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80745c02')) {
      api.createRecord('80745c02', component.options)
    } else {
      api.reload('80745c02', component.options)
    }
    module.hot.accept("./InfoField.vue?vue&type=template&id=80745c02", function () {
      api.rerender('80745c02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/components/InfoField.vue"
export default component.exports